import { apiGet, apiPost } from './client';

export function dashboardParams(workspace, extra = {}) {
  return { workspace, ...extra };
}

export const fetchMetrics = (ws) => apiGet('/api/dashboard/metrics', { workspace: ws });
export const fetchPnl = (ws, months) => apiGet('/api/dashboard/pnl', { workspace: ws, months });
export const fetchBurnRunway = (ws) => apiGet('/api/dashboard/burn-runway', { workspace: ws });
export const fetchRevenueTrend = (ws, months) =>
  apiGet('/api/dashboard/revenue-trend', { workspace: ws, months });
export const fetchExpenseBreakdown = (ws, period) =>
  apiGet('/api/dashboard/expense-breakdown', { workspace: ws, ...(period ? { period } : {}) });
export const fetchExpenseDrilldown = (ws, ledger) =>
  apiGet('/api/dashboard/expense-drilldown', { workspace: ws, ledger });
export const fetchCashflow = (ws, months) =>
  apiGet('/api/dashboard/cashflow', { workspace: ws, months });
export const fetchReceivables = (ws) => apiGet('/api/dashboard/receivables', { workspace: ws });
export const fetchPayables = (ws) => apiGet('/api/dashboard/payables', { workspace: ws });
export const fetchGstSummary = (ws) => apiGet('/api/dashboard/gst-summary', { workspace: ws });
export const fetchInsights = (ws) => apiGet('/api/dashboard/insights', { workspace: ws });
export const fetchSyncStatus = (ws) => apiGet('/api/workspace/sync-status', { workspace: ws });
export const fetchTransactions = (ws, syncedOnly = true) =>
  apiGet('/api/transactions', { workspace: ws, ...(syncedOnly ? { syncedOnly: '1' } : {}) });

export const postSyncAccounting = (workspace, transactions) =>
  apiPost('/api/sync-accounting', { workspace, transactions });

// MIS & e-commerce endpoints
export const fetchMIS = (ws, period) =>
  apiGet('/api/dashboard/mis', { workspace: ws, ...(period ? { period } : {}) });
export const fetchUnitEconomics = (ws, period) =>
  apiGet('/api/dashboard/unit-economics', { workspace: ws, ...(period ? { period } : {}) });
export const fetchCashForecast = (ws, days = 90) =>
  apiGet('/api/dashboard/cash-forecast', { workspace: ws, days });
export const fetchEcomKpis = (ws, period) =>
  apiGet('/api/dashboard/ecom-kpis', { workspace: ws, ...(period ? { period } : {}) });
export const fetchInventory = (ws, period) =>
  apiGet('/api/dashboard/inventory', { workspace: ws, ...(period ? { period } : {}) });
export const fetchFinanceCalendar = (ws, period) =>
  apiGet('/api/dashboard/finance-calendar', { workspace: ws, ...(period ? { period } : {}) });
export const postCalendarToggle = (id, is_complete) =>
  apiPost('/api/dashboard/finance-calendar/toggle', { id, is_complete });

// Data import endpoints
export const postShopifyImport = (workspace, csv) =>
  apiPost('/api/import/shopify', { workspace, csv });
export const postGatewayImport = (workspace, csv) =>
  apiPost('/api/import/gateway', { workspace, csv });
export const postShippingImport = (workspace, csv) =>
  apiPost('/api/import/shipping', { workspace, csv });
